 <template>
    <q-header reveal class="bg-white text-black shadow-2">
      <q-toolbar>

        <q-img
          src="@/assets/logo.png"
          alt="University Logo"
          style="max-width: 300px;"
        />

        <q-separator vertical inset
          class="q-ml-sm q-mr-sm" />

        <q-toolbar-title class="no-padding">
        Canvas Embed Tool
        </q-toolbar-title>
<!--
        <q-btn
            v-show="!loggedIn"
            flat
            square
            aria-label="Login"
            label="Log In"
            @click="loggedIn = !loggedIn"
        />

        <q-btn
            v-show="loggedIn"
            color="primary"
            aria-label="Account Menu"
            flat
            round
        >
            <q-avatar
                color="primary"
                icon="person"
            />
            <q-menu
            auto-close
            transition-show="jump-down"
            transition-hide="jump-up"
            >
            <q-list style="min-width: 100px">
                <q-item clickable @click="logOut(); loggedIn = !loggedIn">
                    <q-item-section>Log Out</q-item-section>
                </q-item>
            </q-list>
            </q-menu>
        </q-btn> -->
      </q-toolbar>
    </q-header>
</template>
<script>
import { ref } from 'vue'
import { useQuasar } from 'quasar'

export default {
  name: 'navigation-bar',

  setup () {
    const $q = useQuasar()

    return {
      loggedIn: ref(false),
      logOut () {
        $q.notify({
          message: 'Successfully logged out.',
          color: 'accent'
        })
      }
    }
  }
}
</script>
